import { Component } from '@angular/core';

@Component({
  selector: 'app-stake-and-holdings',
  templateUrl: './stake-and-holdings.component.html',
  styleUrls: ['./stake-and-holdings.component.css']
})
export class StakeAndHoldingsComponent {
  mode: 'stake' | 'hold' = 'stake';

  getDurations(): string[] {
    return this.mode === 'stake'
      ? ['365 Days', '180 Days', '90 Days']
      : ['30 Days', '15 Days', '7 Days'];
  }
}
